import React from 'react';
import { IToggleButtonProps } from './types';
import { useToggleButtonGroup } from '../useToggleButtonGroup';
import styles from './ToggleButton.module.css';

export const ToggleButton: React.FC<IToggleButtonProps> = ({
  id,
  children,
}) => {
  const { activeKey, setActiveKey } = useToggleButtonGroup();

  return (
    <button className={`${styles.button} ${id === activeKey && styles.active}`} type="button" onClick={() => setActiveKey(id)}>
      {children}
    </button>
  );
};
